export const BULK_SUBMIT_SELECT_SOURCE = 'select_source';
export const BULK_SUBMIT_VALIDATE_DATA = 'validate_data';
export const BULK_SUBMIT_SUBMITTED = 'review';
